export const environment = {
  production: false,
  baseUrl: "https://crihub.informaticsapplied.com",
  inActivityTime: 86400000,
  hub_version: "26.11.01.1",
};
